import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";

const PILL = {
  recommended: "bg-purple-600 text-white", available: "bg-emerald-100 text-emerald-800", requires_response: "bg-amber-100 text-amber-900",
  requires_evidence: "bg-amber-100 text-amber-900", not_applicable: "bg-slate-100 text-slate-600", admin_disabled: "bg-slate-200 text-slate-600",
};
const RECIPIENT = { bureau: "Credit bureau", furnisher: "Data furnisher (creditor)", collector: "Debt collector", creditor: "Original creditor", regulator: "Regulator (CFPB / state)" };
const FIELD = { account_id: "The account", disputed_fields: "What is wrong and what it should show", explanation: "Your factual explanation",
  requested_action: "What you are asking for", recipient_address: "Recipient mailing address", prior_dispute: "Previous dispute date and result",
  duplicate_of: "The duplicate listing", date_of_first_delinquency: "Date of first delinquency", account_paid: "Confirmation the account is paid" };

export function LetterCard({ card, lookups, onUse, highlight }) {
  const usable = card.status === "recommended" || card.status === "available";
  const ev = (card.required_evidence || []).map((r) => (r === "any" ? "At least one supporting document" : r.split("|").map((k) => lookups.evidence[k]).join(" or ")));
  return (
    <li className={`rounded-2xl border p-5 bg-white ${highlight ? "border-purple-300 ring-2 ring-purple-100" : "border-slate-200"} ${usable ? "" : "opacity-90"}`} data-testid={`letter-card-${card.letter_key}`}>
      <div className="flex items-start justify-between gap-3">
        <h4 className="font-semibold text-slate-900">{card.name}</h4>
        <span className={`shrink-0 text-xs font-semibold rounded-full px-2.5 py-1 ${PILL[card.status]}`} data-testid={`letter-card-status-${card.letter_key}`}>{card.status_label}</span>
      </div>
      <p className="mt-1 text-sm text-slate-600">{card.purpose}</p>
      {card.note && (
        <p className="mt-2 flex gap-2 rounded-xl bg-sky-50 border border-sky-200 p-3 text-xs text-sky-900" data-testid={`letter-card-note-${card.letter_key}`}>
          <Info size={14} className="shrink-0 mt-0.5" />{card.note}
        </p>
      )}
      <dl className="mt-3 grid gap-2 text-xs text-slate-700">
        <div><dt className="font-semibold text-slate-900">Sent to</dt><dd>{RECIPIENT[card.recipient_type]}</dd></div>
        <div><dt className="font-semibold text-slate-900">When to use it</dt><dd>{card.when_to_use}</dd></div>
        <div><dt className="font-semibold text-slate-900">When not to use it</dt><dd>{card.when_not_to_use}</dd></div>
        <div><dt className="font-semibold text-slate-900">Information you'll need</dt><dd>{card.required_fields.map((f) => FIELD[f] || f).join(" · ")}</dd></div>
        <div><dt className="font-semibold text-slate-900">Supporting documents</dt><dd>{ev.length ? ev.join(" · ") : "Your ID and proof of address (added when mailing)"}</dd></div>
      </dl>
      {!usable && card.unmet?.length > 0 && <p className="mt-3 text-xs text-amber-800" data-testid={`letter-card-unmet-${card.letter_key}`}>{card.unmet.join(" ")}</p>}
      <Button onClick={() => onUse(card)} disabled={!usable} className="mt-4 w-full sm:w-auto min-h-[44px] rounded-xl btn-primary" data-testid={`letter-card-use-${card.letter_key}`}>
        Use this letter
      </Button>
    </li>
  );
}
